import React from 'react'
import { Box, Carousel } from '@alto-avios/alto-ui'
import { useDeviceMatch } from '~/context/mediaQuery'
import PromotionalBannerItem from './PromotionalBannerItem'
import { PromotionalBannersProps } from './PromotionalBanners.types'
import styles from './PromotionalBanners.module.scss'

const PromotionalBanners = ({ banners, isSingleBannerFullWidth }: PromotionalBannersProps) => {
  const { isMobile } = useDeviceMatch()

  if (!banners || banners.length === 0) {
    return null
  }

  const isSingle = banners.length === 1
  const isSingleFullWidth = isSingle && isSingleBannerFullWidth

  if (isMobile) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        width="full"
        dataTestId="promotional-banners"
        className={isSingleFullWidth ? styles.singleBannerFullWidth : undefined}
      >
        {isSingle ? (
          <PromotionalBannerItem {...banners[0]} single />
        ) : (
          <Carousel
            itemsPerPage={1.15}
            spaceBetweenItems={12}
            hideDots
            carouselWrapperClassName={styles.carouselFullWidth}
            prevArrowClassName={styles.hiddenArrow}
            nextArrowClassName={styles.hiddenArrow}
            aria-label="Promotional banners"
          >
            {banners.map((banner) => (
              <Box key={banner.id}>
                <PromotionalBannerItem {...banner} />
              </Box>
            ))}
          </Carousel>
        )}
      </Box>
    )
  }

  const getDesktopClassName = () => {
    if (banners.length > 1) return styles.desktopLayout
    if (isSingleFullWidth) return styles.singleBannerFullWidth
    return undefined
  }

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      gap="md"
      width="full"
      dataTestId="promotional-banners"
      className={getDesktopClassName()}
    >
      {banners.map((banner) => (
        <PromotionalBannerItem key={banner.id} {...banner} single={isSingle} />
      ))}
    </Box>
  )
}

export default PromotionalBanners
